<template>
    <div class="agr">
      <!-- 导航栏 -->
      <nav-header :href="this.href"></nav-header>
  
      <div class="container">
        <h1>退费方式</h1>
        <h2>
            会员开通后享受相应的权利，正常运营过程中不同档位的会员可以享受下载对应的产品数。
        </h2>
  
        <h2>用户即使本月支付了相应的会员费本月没有下载任意一款或者少量产品，都不会退回相应剩余费用。如果因为公司经营出现变化的，比如停业、不再经营此类互联网文化产品内容时产生的用户缴费后而没有享受到相应服务的，我们会根据用户付费的时间，使用次数进行费用分摊。分摊后，用总的会员费扣除分摊掉的费用通过邮件、注册时预留的手机号进行联系，无法联系的会直接按照原支付路线退回未使用的部分费用。</h2>
        <!-- <p>
          2.1儿童的个人信息属于敏感个人信息，请父母或监护人谨慎对待儿童个人信息,教育引导儿童增强个人信息保护意识和能力，指导、提醒和要求他们在未经您同意的情况下，不
          向任何网络产品和服务提供者提供任何个人信息，并确保您的孩子的相关操作(如授权、信息提供等)在您的同意后进行。
        </p>
        <p>2.2如果未取得父母或监护人的同意,儿童不应创建自己的个人信息主体账户。</p>
        <p>
          2.3对于经父母或监护人同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情祝下使用或公开披露此信息。
        </p> -->
  
        <h2>
            管理措施：公司会建立台账，上面会列明所有缴费用户的清单，包含缴费时间、类别等。如发生退费或缴费故障，公司会及时查看确认。确认无误后按照要求处理。
        </h2>
        <p></p>
  
        
        <div class="blink"></div>
      </div>
    </div>
  </template>
  
  <script>
  import NavHeader from "./../components/h2";
  export default {
    name: "agreement",
    components: {
      NavHeader,
    },
    data() {
      return {
        href: "index.html",
      };
    },
    mounted() {
      document.title = "晋江奇境 ";
    },
  };
  </script>
  <style lang="scss" scoped>
  @import "./../assets/scss/base.scss";
  @import "./../assets/scss/config.scss";
  @import "./../assets/scss/mixin.scss";
  .agr {
    .container {
      width: 980px;
      padding-top: 30px;
      h1 {
        font-size: 18px;
        font-weight: bold;
      }
      h2 {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin: 20px 0;
        line-height: 31px;
      }
  
      p {
        text-indent: 30px;
        font-size: 14px;
        line-height: 31px;
        margin: 20px 0 40px;
        color: #888;
      }
  
      h3 {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin: 15px 0;
        span {
          font-size: 14px;
          color: #888;
          font-weight: normal;
        }
      }
  
      .blink {
        width: 100%;
        height: 1px;
        background: #ccc;
        margin-bottom: 30px;
      }
    }
  }
  </style>
  